module.exports = __webpack_public_path__ + "static/jidong-huang-e9074e5fdc2ff2fc3da9285cf62f234c.jpg";